export default "__VITE_ASSET__BFYIHjYy__"